import {Component, TemplateRef} from '@angular/core';
import {ToastService} from '../../services/toast.service';

@Component({
    selector: 'app-toast-notify',
    templateUrl: './toast-notify.component.html',
    styleUrls: ['./toast-notify.component.scss']
})
export class ToastNotifyComponent {

    constructor(
        public toastService: ToastService
    ) {
    }


    isTemplate(toast): boolean {
        return toast.textOrTpl instanceof TemplateRef;
    }
}
